/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { ScheduleReportProcessingViewModel } from './ScheduleReportProcessingViewModel'; 

export function getLegacyScheduleReportProcessingOptions(onSuccess?: (result: ScheduleReportProcessingViewModel) => void) {
	return queryOptions({
		queryKey: ['legacy-schedule-report-processing'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/scheduling/queries/getlegacyschedulereportprocessing/';
			const resp = await axios.get<ScheduleReportProcessingViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}